import axios from "axios";
import _ from "lodash";
import moment from "moment";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import {
  APP_API_KEY,
  INSTANCE_URL,
  DATE_FORMAT,
  DEVELOPMENT_TYPE,
} from "Constants";
import { isEmpty } from "ActionsSpeakers";
import { updateEvent } from "ActionsMessage";
import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
} from "NetworkCall";

export var ANALYTICS_UPDATE_DATE_PROPS    = "ANALYTICS_UPDATE_DATE_PROPS";
export var ANALYTICS_FETCH_SCHEDULE_DATE  = "fetch_sechdule_date";
export var ANALYTICS_UPDATE_SCHEDULE_DATE = "update_schedule_date";

export function analyticsUpdateDateProps(values) {
    return (dispatch) => {
      dispatch({ type: ANALYTICS_UPDATE_DATE_PROPS, payload: values });
    };
}

export function analyticsDateRangeUpdate(object) {
  var startDate = moment(object.startDate);
  var endDate = moment(object.endDate);
  var allDate = [];
  var day = {};
  var n = endDate.diff(startDate, "days") + 1;
  for (var i = 1; i <= n; i++) {
    if (i !== 1) {
      day = moment(day).add(1, "days");
    } else {
      day = startDate;
    }
    allDate.push({ scheduledate: moment(day).format(DATE_FORMAT) });
  }
  object = { ...object, allDate };
  return (dispatch) => {
    dispatch({ type: ANALYTICS_FETCH_SCHEDULE_DATE, payload: object });
    dispatch({ type: ANALYTICS_UPDATE_SCHEDULE_DATE, payload: allDate });
  };
}